/**
 * OVERRIDE SummaryTemplate.jsx
 * REASON: This theme allows the usage of a custom ItemBodyTemplate
 * depenging on the item's content type for the Summary listing variation.
 * To override it, override the @kitconcept/volto-light-theme one instead of
 * this one.
 */

import SummaryTemplate from '../../../../../../components/Blocks/Listing/SummaryTemplate';

export default SummaryTemplate;
